(() => {
  if (customElements.get('sibrille-support-contact')) return;

  customElements.define('sibrille-support-contact', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.menu = this.querySelector('details');
      this.launcher = this.querySelector('summary');
      this.error = this.querySelector('[data-support-status]');
      this.nativeOpen = false;
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.sync();
        });
      };
      this.outsideClick = (event) => {
        if (!event.composedPath().includes(this)) this.menu.open = false;
      };
      this.escapeKey = (event) => {
        if (event.key === 'Escape' && this.menu.open) {
          this.menu.open = false;
          this.launcher.focus();
        }
      };
      this.querySelectorAll('[data-support-live]').forEach(link => link.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const host = document.querySelector('shopify-chat');
        if (!host || typeof host.show !== 'function') {
          this.error.hidden = false;
          return;
        }
        this.error.hidden = true;
        host.inert = false;
        document.documentElement.classList.add('sibrille-support-native-open');
        // Public web component interface; no synthetic clicks or iframe changes.
        host.show();
        this.sync();
        if (!this.nativeOpen) this.error.hidden = false;
      }));
      this.querySelector('[data-support-close]').addEventListener('click', () => {
        this.menu.open = false;
        this.launcher.focus();
      });
      const finder = this.querySelector('[data-lamp-finder]');
      const home = this.querySelector('[data-support-home]');
      this.querySelector('[data-finder-open]')?.addEventListener('click', () => {
        home.hidden = true;
        finder.hidden = false;
        finder.querySelector('[data-finder-heading]').focus({ preventScroll: true });
      });
      this.querySelector('[data-finder-back]')?.addEventListener('click', () => {
        finder.hidden = true;
        home.hidden = false;
        this.querySelector('[data-finder-open]').focus({ preventScroll: true });
      });
      const form = this.querySelector('[data-finder-form]');
      const updateMatches = () => {
        const use = form.elements.use.value;
        const mode = form.elements.mode.value;
        const amount = form.elements.budget.value.trim();
        const budget = amount === '' ? Infinity : Number(amount) * 100;
        const seen = new Set();
        let shown = 0;
        this.querySelectorAll('[data-finder-card]').forEach(card => {
          const match = card.dataset.use === use && card.dataset.mode === mode &&
            Number(card.dataset.price) <= budget + 0.001 && !seen.has(card.dataset.product) && shown < 2;
          card.hidden = !match;
          if (match) { shown++; seen.add(card.dataset.product); }
        });
        this.querySelector('[data-finder-results]').hidden = !use;
        this.querySelector('[data-finder-empty]').hidden = shown !== 0;
        this.querySelector('[data-finder-price-note]').hidden = shown === 0;
      };
      form?.addEventListener('submit', event => { event.preventDefault(); updateMatches(); });
      form?.addEventListener('input', () => {
        if (!this.querySelector('[data-finder-results]').hidden) updateMatches();
      });
      this.bodyObserver = new MutationObserver(this.schedule);
      this.bodyObserver.observe(document.body, { childList: true, subtree: true });
      document.addEventListener('click', this.outsideClick);
      document.addEventListener('keydown', this.escapeKey);
      document.documentElement.classList.add('sibrille-support-unified');
      this.sync();
    }
    sync() {
      const host = document.querySelector('shopify-chat');
      if (host !== this.nativeHost) {
        this.nativeObserver?.disconnect();
        this.nativeHost = host;
        if (host) {
          this.nativeObserver = new MutationObserver(this.schedule);
          this.nativeObserver.observe(host, { attributes: true, attributeFilter: ['open'] });
        }
      }
      const open = !!host?.hasAttribute('open');
      if (host) host.inert = !open;
      this.toggleAttribute('data-native-open', open);
      document.documentElement.classList.toggle('sibrille-support-native-open', open);
      if (this.nativeOpen && !open) {
        this.menu.open = true;
        this.launcher.focus({ preventScroll: true });
      }
      if (open) this.menu.open = false;
      this.nativeOpen = open;
    }
    disconnectedCallback() {
      this.bodyObserver?.disconnect();
      this.nativeObserver?.disconnect();
      document.removeEventListener('click', this.outsideClick);
      document.removeEventListener('keydown', this.escapeKey);
      cancelAnimationFrame(this.frame);
      document.documentElement.classList.remove('sibrille-support-unified', 'sibrille-support-native-open');
      if (this.nativeHost) this.nativeHost.inert = false;
      this.nativeHost = null;
      this.initialized = false;
    }
  });
})();
